import { render, staticRenderFns } from "./EipTextOpinion.vue?vue&type=template&id=0bb1418c&scoped=true&"
import script from "./EipTextOpinion.vue?vue&type=script&lang=js&"
export * from "./EipTextOpinion.vue?vue&type=script&lang=js&"
import style0 from "./EipTextOpinion.vue?vue&type=style&index=0&id=0bb1418c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb1418c",
  null
  
)

export default component.exports